module.exports = __webpack_public_path__ + "img/war-logo.c196bc77.jpg";